import React from 'react';
import Header from "../pages/include/Header";
import Sidebar from "../pages/include/Sidebar";
import PWAStatus from "../components/PWAStatus";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

// For GET requests
axios.interceptors.request.use(
    (req) => {
        // Add configurations here
        req.headers.Authorization = 'Bearer ' + sessionStorage.getItem('access_token');
        return req;
    },
    (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
            // sessionStorage.clear();
            // window.location.href = '/login';
            toast.error("Something went wrong..", {
                autoClose: 3000,
                
            });
        }
        return Promise.reject(err);
    }
);

// For POST requests
axios.interceptors.response.use(
    (res) => {
        res.headers.Authorization = 'Bearer ' + sessionStorage.getItem('access_token');
        if (res.status === 401 || res.status === 403) {
            // sessionStorage.clear();
            // window.location.href = '/';
        }
        return res;
    },
    (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
            // sessionStorage.clear();
            // window.location.href = '/';
            toast.error("Something went wrong..", {
                autoClose: 3000,
                
            });
        }

        return Promise.reject(err);
    }
);

const AdminLayout = ({ component: Component }) => {

    const isLogin = sessionStorage.getItem('access_token');
    if (!isLogin) {
        // window.location.href = '/';
    }
    
    return (
        <div className="main-wrapper">
            { isLogin && <Header /> }
            { isLogin && <Sidebar /> }
            { isLogin && <main className="rounded">
                <div className="container-fluid">
                    <PWAStatus />
                    {Component}
                </div>
            </main> }
            <ToastContainer />
        </div>
    )
};

export default AdminLayout;  